export const VERIFICATION_TYPES = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  INCOMPLETE: 'INCOMPLETE',
  ESCALATE: 'ESCALATE',
  DUPLICATE: 'DUPLICATE',
  IDENTITY_VERIFICATION_ATTEMPTS_EXCEEDED:
    'IDENTITY_VERIFICATION_ATTEMPTS_EXCEEDED',
  FORCE_KYC: 'FORCE_KYC',
  FORCE_KYC_DOCUMENT: 'FORCE_KYC_DOCUMENT',
};

export const ENTITY_TYPE_MAP = {
  NONE: 0,
  INDIVIDUAL: 1,
  BUSINESS: 2,
  UNKNOWN: 3,
};

export const NOTIFICATION_TYPES = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  REQUEST_WITHDRAWAL: 'REQUEST_WITHDRAWAL',
  APPROVED_REQUEST_WITHDRAWAL: 'ADMIN_APPROVED_WITHDRAW',
  ADMIN_DECLINED_WITHDRAW: 'ADMIN_DECLINED_WITHDRAW',
  ADMIN_DEPOSIT: 'ADMIN_DEPOSIT',
  EXPIRED_WITHDRAWAL_REQUEST: 'EXPIRED_WITHDRAWAL_REQUEST',
  CANCELLED_WITHDRAWAL_REQUEST: 'CANCELLED_WITHDRAWAL_REQUEST',
  CUSTOMER_REGISTRATION: 'CUSTOMER_REGISTRATION',
  VERIFICATION_APPROVED: 'DOCUMENT_VERIFICATION_APPROVED',
  VERIFICATION_REJECTED: 'VERIFICATION_REJECTED',
  UPDATE_REQUEST_WITHDRAWALS: 'UPDATE_REQUEST_WITHDRAWALS',
};

export const ACCOUNTING_ACCOUNTS = {
  PLAYER_WALLET: 2102,
  ACTUM_PROCESSED_DEPOSITS: 1208,
  WORLDPAY_PROCESSED_DEPOSITS: 1209,
  WORLDPAY_INCOMING_FEE_CHARGE: 4074,
  ACTUM_INCOMING_FEE_CHARGE: 4075,
  TRUST_LIABILITIES_PLAYER_WALLET_DISTRIBUTION_REQUEST: 2103,
};

export const USER_TYPES: { [key: string]: string } = {
  guest: 'Z-Guest',
  member: 'Z-Member',
  player: 'Z-Player',
  zbo: 'ZBO',
};

export const zendeskConfig: { timeOut: number } = {
  timeOut: 60000,
};

export const ZENDESK_CONFIG = zendeskConfig;

export const FZ_ZENDESK_URLS: { [key: string]: string } = {
  location:
    'https://fantaz.zendesk.com/hc/en-us/articles/1500012456481-How-do-I-enable-location-services-in-order-to-play-',
};

export const PAYMENT_CARD_LABEL_BY_TYPE: { [key: string]: string } = {
  CC: 'Credit Card',
  Check: 'Echeck Account',
  ACH: 'Account',
  Paypal: 'Paypal Account',
};

export const WEBSOCKET_NOTIFICATION_TYPE = {
  DEPOSIT: 'DEPOSIT', // User deposited money through a processor
  ADMIN_DEPOSIT: 'ADMIN_DEPOSIT', // Admin deposited money to user's wallet
  WITHDRAW: 'WITHDRAW', // User withdraw money from wallet through a processor
  REQUEST_WITHDRAW: 'REQUEST_WITHDRAW', // User request withdraw
  ADMIN_WITHDRAW: 'ADMIN_WITHDRAW', // Admin withdraw money from user's wallet
  ADMIN_DECLINED_WITHDRAW: 'ADMIN_DECLINED_WITHDRAW', // Admin declined user's withdrawal request
  ADMIN_APPROVED_WITHDRAW: 'ADMIN_APPROVED_WITHDRAW', // Admin approved user's withdrawal request
};

export const PAYMENT_METHOD_TYPE = {
  CC: 'CC',
  ACH: 'ACH',
};
